import { DpButton } from '@/components/blocks/DpLibrary/DpButton';
import { Img } from '@/components/blocks/MaterialImage';
import { Box, Typography } from '@mui/material';
import { DpFanDialogHeader } from '@/components/blocks/DpFanDialog/parts/DpFanDialogHeader';
import { useDpFanInitialStageContext } from '@/components/blocks/DpFanDialog/parts/DpFanInitialStage/context';
import {
	DpFanInitialStageButtonsSx,
	DpFanInitialStageCancelButtonSx,
	DpFanInitialStageContentSx,
	DpFanInitialStageDataSx,
	DpFanInitialStageDescSx,
	DpFanInitialStageFrameSx,
	DpFanInitialStageSubmitButtonSx,
	DpFanInitialStageTitleSx,
} from './styles';
import { DpFanFinishStageDataImageSx } from '@/components/blocks/DpFanDialog/parts/DpFanFinishStage/style';
import { parseHTML } from '@/utils/parseHTML';

interface Props {
	ispage?: boolean;
	src: string;
	title: string;
	subtitle: string;
	ctalabel: string;
	cancellabel: string;
}

export const DpFanQuizInitial = ({
	ispage = true,
	src,
	title,
	subtitle,
	ctalabel,
	cancellabel,
}: Props) => {
	const { onStart, onClose } = useDpFanInitialStageContext();

	return (
		<Box sx={DpFanInitialStageFrameSx(ispage)}>
			<DpFanDialogHeader onClose={onClose} />
			<Box sx={DpFanInitialStageContentSx}>
				<Box sx={DpFanInitialStageDataSx}>
					<Img src={src} alt={title} sx={DpFanFinishStageDataImageSx} />
					<Typography component="h1" sx={DpFanInitialStageTitleSx}>
						{title}
					</Typography>
					<Typography sx={DpFanInitialStageDescSx}>{subtitle}</Typography>
				</Box>
				<Box sx={DpFanInitialStageButtonsSx}>
					<DpButton
						variant="unfocused"
						fullWidth
						sx={DpFanInitialStageCancelButtonSx}
						onClick={onClose}
					>
						{parseHTML(cancellabel)}
					</DpButton>
					<DpButton
						variant="primary"
						fullWidth
						sx={DpFanInitialStageSubmitButtonSx}
						onClick={onStart}
					>
						{parseHTML(ctalabel)}
					</DpButton>
				</Box>
			</Box>
		</Box>
	);
};
